// extracted by mini-css-extract-plugin
module.exports = {"delivery-groby":"_2w9JiUsx","deliveryGroby":"_2w9JiUsx"};